import { contentfulInterface } from '../contentful'
export const cmsProvider = contentfulInterface
